import { Status } from '@kc-console/common-ui';
import { TaskStatusType } from '@kc-console/context';

import type { StatusSize, StatusType, StatusVariant } from '@kc-console/common-ui';

interface TaskStatusIconProps {
  statusType: string;
  /** Status 컴포넌트 크기 토큰. 카드=lg(T16), 상세 step=sm. */
  size?: StatusSize;
  /** 아이콘 채움. 카드=filled(꽉 참), 미니뷰=line(안이 뚫린 Regular). */
  variant?: StatusVariant;
}

/**
 * Task `statusType`을 DS `Status` 아이콘으로 매핑.
 * @description
 * - IN_PROGRESS → indeterminate-progress(스피너), SUCCESS → active(초록 체크), FAILED → error(빨강).
 * - WARNING(부분 실패) → warning(노랑 경고 삼각형).
 * - 카드/상세 step이 공유한다.
 */
const STATUS_MAP: Record<string, StatusType> = {
  [TaskStatusType.IN_PROGRESS]: 'indeterminate-progress',
  [TaskStatusType.SUCCESS]: 'active',
  [TaskStatusType.FAILED]: 'error',
  [TaskStatusType.WARNING]: 'warning',
  [TaskStatusType.SKIPPED]: 'inactive',
};

const TaskStatusIcon = ({ statusType, size = 'lg', variant = 'filled' }: TaskStatusIconProps) => {
  const status = STATUS_MAP[statusType] ?? 'unknown';
  return <Status status={status} size={size} variant={variant} hideLabel />;
};

export default TaskStatusIcon;
